(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("s-main-cart")) {
  customElements.define(
    "s-main-cart",
    class SectionCartModal extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;

        this.headerItemCount = document.querySelector(".js-header__cart-count");
        
        this.addEventsListeners();

        window.PubSub.subscribe('cart:update', this.updateCart);
      }

      disconnectedCallback() {
      }

      updateCart = () => {
        this.classList.add("is-loading");
        
        fetch(window.Shopify.routes.root + '?section_id=' + this.sectionId)
        .then(response => response.text())
        .then(html => {
          let newSection = document.createElement('div');
          newSection.innerHTML = html;
          let newCartModal = newSection.querySelector('.s-main-cart');
          this.dataset.collectionHandle = newCartModal.dataset.collectionHandle;
          
          this.innerHTML = newCartModal.innerHTML;
          this.headerItemCount.innerHTML = this.querySelector(".js-main-cart__count").innerHTML;
          this.classList.remove("is-loading");

          this.addEventsListeners();
        })
        .catch(error => console.error(error));
      }

      addEventsListeners = () => {
        this.note = this.querySelector(".js-main-cart__note");

        this.note.addEventListener("change", this.noteUpdater);
      }

      noteUpdater = () => {

        fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ note: this.note.value }),
        })
        .then(response => response.json())
        .then(data => {
            console.log("Note updated:", data);
        })
        .catch(error => console.error("Error updating note:", error));
      }
    }
  );
}

},{}]},{},[1])

